import { AppBar, Toolbar, IconButton, Typography, Menu, MenuItem, Box, } from '@mui/material';
import { AccountCircle ,Logout} from '@mui/icons-material';
import { useState } from 'react';
import logo from '../assets/images/defaults/logo-light.png';
export default function Header({user, onLogout, navigateToHome, navigateToPanel }){
    const [anchorEl, setAnchorEl] = useState(null);
 

    function handleMenuOpen(event){
        setAnchorEl(event.currentTarget);
    }

    function handleMenuClose(){
        setAnchorEl(null);
    }

    function handleLogout(){
        handleMenuClose();
        onLogout();
    }

    return(
        <AppBar position="fixed" sx={{px: '2rem'}}>
            <Toolbar disableGutters>
                <Typography sx={{ flexGrow: 1, cursor: 'pointer' }}>
                    <img onClick={()=>{navigateToHome()}} alt="Logo" src={logo} style={{
                        width: 230,
                        height: 40
                    }} />
                </Typography>
                <div>
                    <IconButton size="large" aria-label="account of current user"  onClick={handleMenuOpen} color="inherit">
                        <AccountCircle />
                    </IconButton>
                    <Menu id="menu-appbar" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleMenuClose}>
                        <MenuItem sx={{px: '1rem', borderBottom:'1px solid grey', display: 'flex', flexDirection: 'column',cursor:'default'}} >
                            <Box display="flex" alignItems="center">
                                <Box display='flex' flexDirection='column' >
                                    <Typography variant='subtitle1' style={{fontWeight:'bold',wordWrap:'break-word',    whiteSpace: 'normal' }}> {user ? user.fullname:''}</Typography> 
                                  {user && user.is_active && <Typography variant='subtitle2' onClick={()=>navigateToPanel()} sx={{cursor:'pointer'}}>{user.role_id===2  ? 'Admin Panel' : 'Application Insights'}</Typography>  }  
                                </Box>
                            </Box>
                        </MenuItem>
                        {/* <MenuItem sx={{px: '2rem', py: '1rem', borderBottom:'1px solid grey', display: 'flex', flexDirection: 'column'}}>
                            <Box display="flex" alignItems="center">
                                <LightMode />
                                <Switch
                                    checked={colorMode!=='light'}
                                    onChange={(e)=>{
                                        if(e.target.checked){
                                            setColorMode('dark');
                                            handleColorMode('dark', theme.dark)
                                        }else{
                                            setColorMode('light');
                                            handleColorMode('light', theme.light)
                                        }
                                    }}
                                    color={muiTheme&&muiTheme.palette.mode==='dark'? 'primary.contrastText' : 'primary'}
                                />
                                <DarkMode />
                            </Box>
                        </MenuItem> */}
                        <MenuItem sx={{px: '1rem'}} onClick={()=>handleLogout()}><Logout style={{marginRight: '1rem'}} />Logout</MenuItem>
                    </Menu>
                </div>
            </Toolbar>
        </AppBar>
    )
}